import { HttpContextToken } from '@angular/common/http';

export const TWO_FA_TOKEN = new HttpContextToken<string | null>(() => null);
